import { render, staticRenderFns } from "./HallOfFame.vue?vue&type=template&id=87a65f14&scoped=true"
import script from "./HallOfFame.vue?vue&type=script&lang=js"
export * from "./HallOfFame.vue?vue&type=script&lang=js"
import style0 from "./HallOfFame.vue?vue&type=style&index=0&id=87a65f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a65f14",
  null
  
)

export default component.exports